import { Card } from "@mui/material";
import { CardActionArea } from "@mui/material";
import { CardContent } from "@mui/material";
import { Typography } from "@mui/material";
import { RequestReason } from "../request-access/sharedTypes";
import { useGetTranslatedReasons } from "../request-access/useGetTranslatedReasons";

// import './selectcards.scss'

export interface SelectableCardProps extends React.PropsWithChildren {
  requestReason: RequestReason;
  selectedItems: RequestReason[];
  handleClick: (clickedReason: RequestReason) => void;
}

const SelectableCard = ({
  requestReason,
  selectedItems,
  handleClick,
}: SelectableCardProps) => {
  const getTranslatedReasons = useGetTranslatedReasons();

  const getTranslatedReason = (englishKey: string) => {
    return getTranslatedReasons([englishKey])[0];
  };
  const isSelected = () => {
    if (
      selectedItems.find(
        (el) => el.reasonEnglishKey === requestReason.reasonEnglishKey
      )
    ) {
      return {
        border: "2px solid #268A95",
      };
    }
    return {
      border: "2px solid transparent",
    };
  };

  return (
    <Card
      sx={{
        // width: "100%",
        height: "100%",
        minHeight: "100px",
        backgroundColor: "#F4F4F4",
        boxShadow: "0 1px 2px #0000001f, 0 1px 1px rgba(0,0,0,0.30)",
        ...isSelected(),
        "&:hover": {
          boxShadow: "0 14px 28px #00000040, 0 10px 10px rgba(0,0,0,0.22)",
        },
      }}
    >
      <CardActionArea
        id={`card_${requestReason.reason}`}
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <CardContent
          onClick={() => {
            handleClick(requestReason);
          }}
        >
          <Typography gutterBottom variant="h5" component="div">
            {getTranslatedReason(requestReason.reasonEnglishKey).reason}

          </Typography>

        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default SelectableCard;
